import React from "react";
import DOMPurify from "dompurify";
import { Row, Col, Skeleton } from "antd";
function UserContract({ contract }) {
  const cleanedContract = DOMPurify.sanitize(contract);
  if (!contract)
    return (
      <>
        <Skeleton active round />
      </>
    );
  return (
    <Row justify="space-around" align="middle">
      <Col xs={24} md={16}>
        <div dangerouslySetInnerHTML={{ __html: cleanedContract }}></div>
      </Col>
    </Row>
  );
}

export default UserContract;
